import React, { Component } from 'react';
import { withRouter } from 'react-router'
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { PageTemplate, PageTitle, Container, TabsNavigation, TopFixed } from '../PageTemplate';
import { Page404 } from '../Page404';
import { EventsActions } from '../../actions';
import { ValidateDate } from '../../helper';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faWarehouse, faCog, faImages} from '@fortawesome/fontawesome-free-solid';
import './eventPageTemplate.scss';

class EventPageTemplate extends Component {
    constructor(props) {
        super(props);

        this.state = {
            eventID: null,
            data: {}
        }
    }

    componentDidMount() {
        const {dispatch} = this.props;
        const eventID = this.state.eventID;
        
        dispatch(EventsActions.getEventData(eventID));
        dispatch(EventsActions.setCurrentEventID(eventID));
    }

    componentWillUnmount() {
        const {dispatch} = this.props;
        dispatch(EventsActions.unSetCurrentEventID());
    }

    static getDerivedStateFromProps(props, state) {
        const eventID = props.match.params.eventID;
        const events = props.events.list;
        const currentEvent = events && events[eventID] ? events[eventID] : false;

        var nextState = {};

        if(state.eventID !== eventID) {
            nextState.eventID = eventID;
        }

        if(currentEvent && !Object.is(currentEvent, state.data)) {
            const {date} = currentEvent;
            nextState.eventStarted = ValidateDate.isSameOrBeforeNow(date.start, date.timeZone);
            nextState.eventFinised = ValidateDate.itsPast(date.end, date.timeZone);
            nextState.data = currentEvent;
        }
            
        if(Object.is(nextState, {})) return null;
        return nextState;
    }

    render() {        
        const {events, children, id, level2Tabs} = this.props;
        if(events.getEventError === true) return (<Page404/>);
        const eventName = this.state.data.name;

        const pageID = id || 'eventPageTemplate';
        const status = ValidateDate.status(this.state.data.date, this.state.data.closed);

        const addLevel2Tabs = level2Tabs && (<TabsNavigation level="2">{level2Tabs}</TabsNavigation>);

        return (
            <PageTemplate id={pageID}>
                <TopFixed numOfTabsNav={level2Tabs ? 2 : 1}>
                    <PageTitle icon="faCalendarAlt">
                        אירוע:&nbsp;
                        <span className="eventName">{eventName}</span>
                        <div className={`eventStatus ${status}`}>&nbsp;</div>
                    </PageTitle>
                    <TabsNavigation>
                        <NavLink exact to={`/events/${this.state.eventID}`} activeClassName="active">
                            <FontAwesomeIcon icon={faWarehouse}/> כללי
                        </NavLink>
                        <NavLink exact to={`/events/${this.state.eventID}/images`} activeClassName="active">
                            <FontAwesomeIcon icon={faImages}/> מגנטים
                        </NavLink>
                        <NavLink exact to={`/events/${this.state.eventID}/settings`} activeClassName="active">
                            <FontAwesomeIcon icon={faCog}/> הגדרות
                        </NavLink>
                    </TabsNavigation>
                    {addLevel2Tabs}
                </TopFixed>
                <Container>
                    {children}
                </Container>
            </PageTemplate>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        events: state.eventsReducer
    }
}

const EventPageTemplateWithRedux = withRouter(connect(mapStateToProps)(EventPageTemplate));

export {EventPageTemplateWithRedux as EventPageTemplate};


// WEBPACK FOOTER //
// ./src/components/EventPage/EventPageTemplate.jsx